import React from 'react';

import { DataDisputeItemWhere, useDataDisputeByIdQuery } from 'src/api';

import { useInboxItemById } from './useInboxItemById';
import { useInboxItemParamId } from './useInboxItemParamId';

export const useCurrentInboxItemDataDispute = (
  dataDisputeItemsFilter?: DataDisputeItemWhere,
  skip = false,
) => {
  const inboxItemId = useInboxItemParamId();
  const { inboxItem, loading: inboxItemLoading } = useInboxItemById(inboxItemId);

  const { data, loading: dataDisputeLoading } = useDataDisputeByIdQuery({
    variables: {
      filter: { inboxItemId: inboxItem?.id },
      dataDisputeItemsFilter,
    },
    // Both conditions must gate the query: without an inbox item the filter is
    // empty, and `dataDispute` is a findUnique that errors on an empty where.
    skip: !inboxItem || skip,
  });

  const dataDispute = React.useMemo(() => data?.dataDispute, [data?.dataDispute]);

  return {
    dataDispute,
    loading: inboxItemLoading || dataDisputeLoading,
  };
};
